module.exports = __webpack_public_path__ + "img/banner.f4e32afa.png";